import { render, staticRenderFns } from "./live-animals.vue?vue&type=template&id=7b4c307f&"
import script from "./live-animals.vue?vue&type=script&lang=js&"
export * from "./live-animals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports